import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Text } from '@pingux/astro';
import ArrowLeftIcon from '@pingux/mdi-react/ArrowLeftIcon';
import CredentialForm from '@components/CredentialForm';
import { credentialsService } from '@services/credentials';
import { CreateCredentialRequest } from '@app-types/tap-partner-vault';

const CredentialNew: React.FC = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = useCallback(async (data: CreateCredentialRequest) => {
    try {
      setSubmitting(true);
      setError(null);
      const credential = await credentialsService.create(data);
      navigate(`/credentials/${credential.id}`);
    } catch (err) {
      setError('Failed to create credential. Please try again.');
      setSubmitting(false);
    }
  }, [navigate]);

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    marginBottom: '1.5rem',
  };

  return (
      <Box sx={{ padding: '1.5rem 0' }}>
      {/* Page Header */}
      <Box sx={headerStyle}>
        <Button
          variant="link"
          onPress={() => navigate('/')}
          sx={{ padding: '0.5rem', marginLeft: '-0.5rem' }}
        >
          <ArrowLeftIcon size={20} />
        </Button>
        <Box>
          <Text
            as="h1"
            sx={{
              fontSize: '1.5rem',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '0.25rem',
            }}
          >
            Add New Credential
          </Text>
          <Text sx={{ color: '#6b7280', fontSize: '0.875rem' }}>
            Store a new partner tenant credential securely
          </Text>
        </Box>
      </Box>

      {/* Error Message */}
      {error && (
        <Box
          sx={{
            padding: '1rem',
            backgroundColor: '#fee2e2',
            borderRadius: '0.5rem',
            marginBottom: '1.5rem',
            borderLeft: '4px solid #dc2626',
          }}
        >
          <Text sx={{ color: '#991b1b' }}>{error}</Text>
        </Box>
      )}

      {/* Form */}
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CredentialForm
          onSubmit={handleSubmit}
          loading={submitting}
        />
      </Box>
    </Box>
  );
};

export default CredentialNew;
